/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'townsquare.townsquare-tags.tag': 'Odebrat štítek',
  'townsquare.townsquare-tags.tooltip-usage-count':
    '{usageCount, plural, one {Používá se na {usageCount,number} místě} few {Používá se na {usageCount,number} místech} many {Používá se na {usageCount,number} místa} other {Používá se na {usageCount,number} místech}}',
};
